module.exports = __webpack_public_path__ + "img/stage5.7ffd6347.png";